/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Company_Detail_Remove_User_TooltipInputs */

const en_admin_company_detail_remove_user_tooltip = /** @type {(inputs: Admin_Company_Detail_Remove_User_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove from company`)
};

const de_admin_company_detail_remove_user_tooltip = /** @type {(inputs: Admin_Company_Detail_Remove_User_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aus Unternehmen entfernen`)
};

/**
* | output |
* | --- |
* | "Remove from company" |
*
* @param {Admin_Company_Detail_Remove_User_TooltipInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const admin_company_detail_remove_user_tooltip = /** @type {((inputs?: Admin_Company_Detail_Remove_User_TooltipInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Company_Detail_Remove_User_TooltipInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_admin_company_detail_remove_user_tooltip(inputs)
	return en_admin_company_detail_remove_user_tooltip(inputs)
});